import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { App, URLOpenListenerEvent } from "@capacitor/app";
import { useLogger } from "../../services/LogService";

/*
 * Manage links in the same for all platforms
 *
 * See https://capacitorjs.com/docs/guides/deep-links
 */
const AppUrlListener: React.FC<any> = () => {

  const history = useHistory();

  const console = useLogger("AppUrlListener");

  useEffect(() => {
    console.info("useEffect() addListener(appUrlOpen)");
    App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      // Example url: https://portail.ciup.fr/home
      // slug = /home
      const slug = event.url.split(".ciup.fr").pop();
      console.info(
        "URL Open detected, slug = " + slug,
        event
      );
      if (slug) {
        history.push(slug);
      }

      // If no match, do nothing - let regular routing
      // logic take over
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default AppUrlListener;
